import t from "@ext/localization/locale/translate";
import { PageState, PageStateDescription, PageStateFolderSvg, PageStateTitle } from "@ui-kit/PageState";

export const EmptyWelcome = () => {
	return (
		<PageState>
			<PageStateFolderSvg icon="plus" />
			<PageStateTitle className="text-center">{t("welcome.empty.title")}</PageStateTitle>
			<PageStateDescription>
				{t("welcome.empty.description")}
				<br />
				{t("try-later")}
			</PageStateDescription>
		</PageState>
	);
};
